import React from "react";
import { Accordion } from "react-bootstrap";
import cdrFilesService from '../../../services/cdrFilesService';

export default function OrdersListSupplies({
  groupedBySupply,
  itemsCdrFiles,
  selectedIds,
  setSelectedIds,
}) {
  const toggleGroup = (group) => {
    const ids = group.positions.map((p) => p.id);
    const allSelected = ids.every((id) => selectedIds.includes(id));

    setSelectedIds((prev) =>
      allSelected ? prev.filter((x) => !ids.includes(x)) : [...prev, ...ids.filter((x) => !prev.includes(x))]
    );
  };

  return (
    <div style={{ maxHeight: "75vh", overflowY: "auto" }}>
      <Accordion alwaysOpen>
        {groupedBySupply.map((group, idx) => {
          const ids = group.positions.map((p) => p.id);

          const all = ids.every((id) => selectedIds.includes(id));
          const some = !all && ids.some((id) => selectedIds.includes(id));

          return (
            <Accordion.Item eventKey={idx} key={group.supplyId + idx}>
              <Accordion.Header>
                <input
                  type="checkbox"
                  className="form-check-input me-2"
                  checked={all}
                  ref={(el) => el && (el.indeterminate = some)}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    e.stopPropagation();
                    toggleGroup(group);
                  }}
                />
                {group.supply?.name || "Без поставки"} —
                <span className="ms-2">
                  ({ids.filter((x) => selectedIds.includes(x)).length}/{ids.length})
                </span>
              </Accordion.Header>
              <Accordion.Body>
                {group.positions.map((p) => (
                  <div key={p.id} className="border p-2 mb-2 d-flex">
                    <input
                      type="checkbox"
                      className="form-check-input me-2"
                      checked={selectedIds.includes(p.id)}
                      onChange={() =>
                        setSelectedIds((prev) =>
                          prev.includes(p.id)
                            ? prev.filter((x) => x !== p.id)
                            : [...prev, p.id]
                        )
                      }
                    />
                    
                    {itemsCdrFiles[p.itemId]?.imageId ? (
                                            <img className="me-2"
                                              src={cdrFilesService.getCdrfilePreview(itemsCdrFiles[p.itemId]?.imageId)}
                                              alt={p.article}
                                              style={{
                                                width: 100,
                                                height: 100,
                                                objectFit: "contain",
                                                marginRight: 10,
                                              }}
                                            />
                                          ) : (
                                            <div style={{ width: "150px", height: "150px", backgroundColor: "#eee" }} />
                    )}

                    {/* {itemsCdrFiles[p.itemId]?.imageId ? (
                                            <img className="me-2"
                                              src={cdrFilesService.getCdrfilePreview(itemsCdrFiles[p.itemId]?.imageId)}
                                              alt={p.article}
                                              style={{ width: "150px", height: "150px", objectFit: "contain" }}
                                            />
                                          ) : (
                                            <div style={{ width: "150px", height: "150px", backgroundColor: "#eee" }} />
                    )} */}

                    <div>
                      <strong>{p.name}</strong>
                      <br />
                      <span className="text-muted">{p.article}</span>
                      <br />
                      <small>{new Date(p.creationTime).toLocaleString()}</small>
                    </div>
                  </div>
                ))}
              </Accordion.Body>
            </Accordion.Item>
          );
        })}
      </Accordion>
    </div>
  );
}
